import { render, staticRenderFns } from "./V2DateRangePicker.vue?vue&type=template&id=08f5a361&scoped=true&"
import script from "./V2DateRangePicker.vue?vue&type=script&lang=js&"
export * from "./V2DateRangePicker.vue?vue&type=script&lang=js&"
import style0 from "./V2DateRangePicker.vue?vue&type=style&index=0&id=08f5a361&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f5a361",
  null
  
)

export default component.exports